#import "../../../../../graphql/fragments/email-membership-stats-fragment.graphql"
#import "../../../../../graphql/fragments/sms-membership-stats-fragment.graphql"

#email-marketing/graphql/fragments/email-membership-stats-fragment.graphql

query GetAllMembershipStatsForAudience($audienceId: ID!) {
    audience(id: $audienceId) {
        id
        membershipStats {
            ...EmailMembershipStatsFragment
        }
        smsMembershipStats {
            ...SmsMembershipStatsFragment
        }
    }
}
